import React from "react";
import "./Phonetic.css";

export default function Phonetic(props){
    console.log(props)
return (
    <div className="Phonetic">
        <a href={props.phonetic.audio} target="_blank" rel="noreferrer">
            Listen</a>
        
           <span>{props.phonetic.text}</span>
    </div>
);
}